import {
  utils,
} from '@ama-sdk/core';
import {
  TravelerQuestionnaireAnswer,
} from '@dapi/sdk';
import {
  createExtendedRegulatoryDocument,
  createPersonalDetails,
  createRegulatoryDetailsCategoryRequirement,
  createRegulatoryDetailsRequirements,
  createRegulatoryPhoneNumber,
  MockExtendedRegulatoryDocument,
  MockPersonalDetails,
  MockRegulatoryDetailsCategoryRequirement,
  MockRegulatoryDetailsRequirements,
  MockRegulatoryPhoneNumber,
  todayPlusNdays,
} from '@dapi/sdk/spec';
import {
  globalDob,
  globalExpiryDate,
  globalIssuanceDate,
} from '../dictionaries/dates';
import {
  defaultContactName,
  namedTraveler,
} from './journeyTraveler';

const date = new utils.Date(globalDob);
const expiryDate = new utils.Date(globalExpiryDate);
const issuanceDate = new utils.Date(globalIssuanceDate);
const saudianNationalityCode = 'SAU';
const saudiaCountryCode = 'SA';
const usCountryOfResidence = 'USA';

export const personalDetails: MockPersonalDetails = createPersonalDetails({
  template: {
    birthDate: date,
    gender: 'male',
    nationalityCode: saudianNationalityCode,
    countryOfResidence: usCountryOfResidence
  }
});

export const idCard: MockExtendedRegulatoryDocument = createExtendedRegulatoryDocument({
  template: {
    documentType: 'identityCard',
    expiryDate: expiryDate,
    issuanceCountryCode: saudiaCountryCode,
    nationalityCode: saudianNationalityCode,
    number: 'ID1234',
    name: namedTraveler.names[0]
  }
});

export const passport: MockExtendedRegulatoryDocument = createExtendedRegulatoryDocument({
  template: {
    documentType: 'passport',
    expiryDate: expiryDate,
    issuanceCountryCode: saudiaCountryCode,
    nationalityCode: saudianNationalityCode,
    number: 'PASS1234',
    name: namedTraveler.names[0]
  }
});

export const visa: MockExtendedRegulatoryDocument = createExtendedRegulatoryDocument({
  template: {
    documentType: 'visa',
    issuanceDate: issuanceDate,
    issuanceCountryCode: saudiaCountryCode,
    nationalityCode: saudianNationalityCode,
    number: 'VISA1234'
  }
});

export const defaultPhoneNumber: MockRegulatoryPhoneNumber = createRegulatoryPhoneNumber({
  template: {
    countryCode: saudiaCountryCode,
    name: defaultContactName,
    number: '8000325234',
    purpose: 'emergencyContact'
  }
});

export const countryExitDate: TravelerQuestionnaireAnswer = {
  countryExitDate: new utils.Date(todayPlusNdays('09:00', 370)),
  documentType: 'questionnaire'
};

export const missingPersonalDetailsChoice: MockRegulatoryDetailsCategoryRequirement = createRegulatoryDetailsCategoryRequirement({
  template: {
    isOptional: false,
    detailsCategory: 'personalDetails',
    detailsChoices: [
      createRegulatoryDetailsRequirements({
        template: {
          canBeDeclined: false,
          detailsType: 'personalDetails',
          regulatoryType: 'personalDetails',
          requiredDetailsFields: ['nationalityCountryCode']
        }
      })
    ]
  }
});

export const missingIdentityCardRequiments: MockRegulatoryDetailsRequirements = createRegulatoryDetailsRequirements({
  template: {
    canBeDeclined: false,
    detailsType: 'document',
    regulatoryType: 'identityCard',
    requiredDetailsFields: ['name', 'number', 'nationalityCountryCode', 'expiryDate']
  }
});

export const missingPassportRequiments: MockRegulatoryDetailsRequirements = createRegulatoryDetailsRequirements({
  template: {
    canBeDeclined: false,
    detailsType: 'document',
    regulatoryType: 'passport',
    requiredDetailsFields: ['name', 'number', 'nationalityCountryCode', 'expiryDate', 'issuanceCountry']
  }
});

export const missingIdentityDocumentChoice: MockRegulatoryDetailsCategoryRequirement = createRegulatoryDetailsCategoryRequirement({
  template: {
    isOptional: false,
    detailsCategory: 'identityDocument',
    detailsChoices: [missingIdentityCardRequiments, missingPassportRequiments]
  }
});

export const missingExitDateRequirements: MockRegulatoryDetailsRequirements = createRegulatoryDetailsRequirements({
  template: {
    canBeDeclined: false,
    detailsType: 'regulatoryDate',
    regulatoryType: 'travelerQuestionnaire',
    requiredDetailsFields: ['countryExitDate']
  }
});

export const missingExitDate: MockRegulatoryDetailsCategoryRequirement = createRegulatoryDetailsCategoryRequirement({
  template: {
    isOptional: false,
    detailsCategory: 'countryExitDocument',
    detailsChoices: [missingExitDateRequirements]
  }
});
